<template>
 <div class="ets-details-container">
  <div class="header-row">

   <h4>{{ trip.etsDetails.serviceType }}</h4>
   <v-chip :color="trip.status.colour" outlined dense>{{ trip.status.name }}</v-chip>
  </div>
  <div class="employees-block">
   <v-card class="employee-list" v-for="(employee, index) in trip.etsDetails.employees" :key="index" elevation="2">
    <div class="name-row">
     <span>{{ employee.name }}</span>
     <span v-if="employee.tripstatus === -1" class="no-show-block">Didn't Show</span>
     <span v-if="employee.tripstatus === 1" class="pickup-block">
      {{ trip.etsDetails.serviceType === "DropOff" ? "Dropped" : "Picked Up" }}
     </span>
    </div>
    <span>{{ employee.mobile }}</span>
    <span>{{ employee.address }}</span>
    <div style="display: flex;flex-direction: column;" class="otp-block" v-if="employee.pickUpDate">
        <span>{{ trip.etsDetails.serviceType === 'PickUp' ? " Pick Up Time" : " Estimated Drop Off Time" }}</span>
     <span>{{ getTimeDate(employee.pickUpDate) }}</span>
     <!-- <v-menu ref="menu" :close-on-content-click="false" transition="scale-transition" max-width="630px" min-width="630px" v-model="employee.dateMenu" v-if="trip.status.id < 7">
      <template v-slot:activator="{ on }">
       <i class="fas fa-pen" v-on="on"></i>
      </template>
      <div class="v-date-time-widget-container">
       <h3 class="text-xs-center">Select Date and Time{{ employee.dateMenu }}</h3>
       <v-layout row wrap>
        <v-flex xs12 sm6>
         <v-date-picker :value="formattedDates[index]" color="black" width="300" @input="updatePickUpDate($event, index)"></v-date-picker>
        </v-flex>
        <v-flex xs12 sm6>
         <v-time-picker :value="formattedTimes[index]" color="black" width="300" format="24hr" @input="updatePickUpTime($event, index)"></v-time-picker>
        </v-flex>
        <v-flex xs12 class="text-xs-center calendar-footer">
         <v-btn small @click="cancelCalendar(employee)" dark>Cancel</v-btn>
         <v-btn small @click="confirm(employee, index)" dark>Ok</v-btn>
        </v-flex>
       </v-layout>
      </div>
     </v-menu> -->
    </div>
    <div style="display: flex;flex-direction: column;" v-if="employee.dropOffTime">
        <span>Estimated Drop Off Time</span>
        <span style="color: green;">{{ getTimeDate(employee.dropOffTime) }}</span>
    </div>
 
   </v-card>
  </div>
 </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
export default {
 name: "ETSDetails",
 props: {
  trip: [Object, String],
 },
 data() {
  return {
   selectedDateTime: "",
  };
 },
 mounted() {
  this.trip.etsDetails.employees.forEach((employee) => {
   if (employee.dateMenu === undefined) {
    this.$set(employee, "dateMenu", false);
   }
  });
 },
 computed: {
  formattedDates() {
   return this.trip.etsDetails.employees.map((employee) => moment(employee.pickUpDate, "DD-MM-YYYY hh:mm A").format("YYYY-MM-DD"));
  },
  formattedTimes() {
   return this.trip.etsDetails.employees.map((employee) => moment(employee.pickUpDate, "DD-MM-YYYY hh:mm A").format("HH:mm"));
  },
 },
 methods: {
  updatePickUpDate(newDate, index) {
   this.selectedDateTime = moment(newDate, "YYYY-MM-DD").format("DD-MM-YYYY hh:mm A");
  },
  updatePickUpTime(newTime, index) {
   const currentDate = moment(this.trip.etsDetails.employees[index].pickUpDate, "DD-MM-YYYY hh:mm A").format("DD-MM-YYYY");
   this.selectedDateTime = moment(`${currentDate} ${newTime}`, "DD-MM-YYYY HH:mm").format("DD-MM-YYYY hh:mm A");
  },
  async confirm(employee) {
   this.$set(employee, "dateMenu", false);
   try {
    const payload = {
     time: moment(this.selectedDateTime ? this.selectedDateTime : employee.pickUpDate, "DD-MM-YYYY hh:mm A").valueOf(),
     id: employee.id,
     tripId: this.trip.token,
    };
    const response = await axios.post("", payload);
    console.log(response);
    if (response.status === 200) {
     this.$toasted.show(response.data, {
      position: "bottom-center",
      duration: 4000,
     });
     this.$emit("tripUpdated");
    }
   } catch (error) {
    console.log(error);
   }
  },
  cancelCalendar(employee) {
   this.selectedDateTime = employee.pickUpDate;
   this.$set(employee, "dateMenu", false);
  },
  getTimeDate(data) {
   return moment(data, "DD-MM-YYYY hh:mm A").format("DD-MM-YYYY HH:mm");
  },
 },
};
</script>

<style scoped lang="scss">
.ets-details-container {
 width: 100%;
 margin: 10px 0;
 font-family: "Muli", sans-serif;
 //border: 1px solid #cfcfcf;
 display: flex;
 flex-direction: column;

 .header-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  border-bottom: 1px solid #cfcfcf;
  padding: 8px;
  h4 {
   font-family: "Muli", sans-serif;
   font-size: 1.2em;
   color: #fa7815;
   text-transform: uppercase;
  }
 }
 .employees-block {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  padding: 10px 0;
  .employee-list {
   width: 49%;
   display: flex;
   flex-direction: column;
   gap: 5px;
   align-items: flex-start;
   padding: 10px;
   background: #fcfcfc;
   border: 1px solid #cfcfcf;
   //border-right: 1px solid #cfcfcf;
   //border-bottom: 1px solid #cfcfcf;
   span {
    font-size: 14px;
    text-align: start;
   }
   .name-row {
    width: 100%;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: #fa7815;

    .no-show-block {
     font-weight: bold;
     color: red;
    }
    .pickup-block {
     font-weight: bold;
     color: green;
    }
   }
   .otp-block {
    font-weight: bold;
    color: grey;
    margin: 5px 0;

    .fas {
     margin-left: 5px;
     color: #256eff;
     cursor: pointer;
    }
   }
   //b {
   //  font-weight: 600;
   //  color: #ad1457;
   //}
   //&:nth-child(even) {
   //  border-right: none;
   //}
  }
 }
}

.v-picker {
 //  box-shadow: 0px 4px 5px 0 rgba(0, 0, 0, 0.14), 0px 1px 10px 0 rgba(0, 0, 0, 0.12), 0px 2px 4px -1px rgba(0, 0, 0, 0.3);
}

.v-date-time-widget-container .flex {
 display: flex;
 flex-direction: column;
 padding: 0 5px;
 justify-content: space-between;
}

.v-date-time-widget-container .flex.text-xs-center {
 flex-direction: row;
 justify-content: flex-end;
 padding: 0;
}

.v-date-time-widget-container {
 background: white;
 padding: 15px;
}

.v-date-time-widget-container {
 background: white;
 padding: 15px;
}

.row {
 margin-top: 0;
}
.v-date-time-widget-container h3 {
 font-weight: 800;
 font-size: 1.1rem;
 //  color: #db670f;
 text-align: center;
 padding: 5px 0;
}
.calendar-footer {
 padding: 5px !important;
}
.v-date-time-widget-container .calendar-footer .v-btn {
 margin-left: 10px;
}
</style>
